var _g, _g2, _g3, _g4, _g5, _g6, _g7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEarthS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_238_248)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.2314,
    cy: 23.8615,
    r: 16.4215,
    transform: "rotate(-134.448 23.2314 23.8615)",
    fill: "#99F9FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_238_248)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.5687,
    cy: 19.6781,
    rx: 1.55696,
    ry: 1.55696,
    fill: "#4A7E52"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_238_248)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.8851,
    cy: 19.6781,
    rx: 1.55696,
    ry: 1.55696,
    fill: "#4A7E52"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_238_248)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.2323,
    cy: 22.055,
    rx: 1.7755,
    ry: 1.3132,
    transform: "rotate(-180 23.2323 22.055)",
    fill: "#68BE76"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_238_248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.789 37.9311C19.2066 36.4735 21.8114 35.9824 22.261 35.9462C23.1254 35.8765 29.4389 36.819 26.7573 32.143C25.2168 29.4567 28.2715 26.4033 31.0247 26.4783C33.7778 26.5534 34.91 20.0287 37.0997 22.0497C39.2894 24.0707 38.135 25.8145 37.4879 26.2641C36.8987 26.6733 31.5171 30.4668 32.5391 30.888C33.561 31.3091 35.0027 31.0843 35.1367 32.931C35.2706 34.7778 26.265 40.4601 21.789 37.9311Z",
    fill: "#A1FF99"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_238_248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0444 11.0895C13.3864 11.6258 13.6102 12.6719 14.4041 12.9724C15.6493 13.4438 17.3517 14.0294 19.0284 14.3265C22.4378 14.9306 22.5529 15.5108 26.2122 12.9534C29.8714 10.396 31.0248 12.8397 31.7475 11.1639C32.514 9.38676 21.5757 4.95184 14.0444 11.0895Z",
    fill: "#A1FF99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9206 36.2681C17.0369 36.8024 16.2773 30.1797 13.1312 25.1463C11.4001 21.4132 12.284 16.7662 10.5234 17.4104C9.36352 17.8347 8.44574 22.7748 9.73202 27.7089C10.8754 31.0168 13.6299 35.1715 15.9206 36.2681Z",
    fill: "#A1FF99"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_238_248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7812 25.8757C27.1861 27.7191 29.8263 24.204 29.8979 23.3682",
    stroke: "#497D51",
    strokeWidth: 0.87913,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_238_248",
    x: 6.52294,
    y: 7.11925,
    width: 33.1294,
    height: 33.1639,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.285652,
    dy: -0.321175
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.35663
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_238_248"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_238_248",
    x: 15.7261,
    y: 17.8354,
    width: 3.39893,
    height: 3.39991,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.285652,
    dy: -0.285652
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.428478
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_238_248"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_238_248",
    x: 27.0425,
    y: 17.8354,
    width: 3.39893,
    height: 3.39991,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.285652,
    dy: -0.285652
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.428478
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_238_248"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_238_248",
    x: 21.1714,
    y: 20.4565,
    width: 3.83643,
    height: 2.91163,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.285652,
    dy: -0.285652
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.285652
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_238_248"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_238_248",
    x: 20.3784,
    y: 21.34,
    width: 17.9966,
    height: 17.2294,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.285652,
    dy: -0.321175
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.71413
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_238_248"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_238_248",
    x: 8.81982,
    y: 7.62511,
    width: 22.9653,
    height: 28.6737,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.285652,
    dy: -0.321175
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.71413
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_238_248"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_238_248",
    x: 18.0542,
    y: 22.6431,
    width: 12.2817,
    height: 4.19971,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.285652,
    dy: -0.285652
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.357065
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_238_248"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarthS);
export default __webpack_public_path__ + "static/media/EarthS.8589a69e0dd70bae2a1128b609d60c86.svg";
export { ForwardRef as ReactComponent };